var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_2101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.76056 13.3153C3.83442 13.2647 3.91803 13.231 4.00363 13.2172L25.4118 9.76555C25.6924 9.72031 25.9262 9.89573 25.934 10.1574C25.9367 10.2473 25.9119 10.3398 25.8626 10.424L14.9025 29.1349C14.7588 29.3801 14.4469 29.4962 14.2058 29.3944C14.1322 29.3632 14.0709 29.3138 14.0276 29.2504L3.5795 13.9911C3.43743 13.7836 3.5185 13.481 3.76056 13.3153ZM6.63784 14.6968L10.0422 19.6689L14.4252 16.6679L15.4542 18.1707L11.0712 21.1717L14.4756 26.1439L22.6975 12.1075L6.63784 14.6968Z",
    fill: "#FFF7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_2101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4973,
    height: 21.8549,
    fill: "white",
    transform: "translate(0 14.4049) rotate(-34.3994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.dcce6ba573d037b4f13b2eb19658da5a.svg";
export { ForwardRef as ReactComponent };